import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";


const app = createApp(App);
app.use(router);
app.mount("#app");

 // app.config.globalProperties.$backendUrl =  "http://jaguarux-001-site54.ktempurl.com/api/"; // Define la URL del backend globalmente
//
 app.config.globalProperties.$backendUrl =  "https://traslados.chiapasincentives.com/api/"; // Define la URL del backend globalmente  
//
// app.config.globalProperties.$backendUrl =  "http://localhost/Proyecto/SistemaTraslado/backend/api/"; // Define la URL del backend globalmente

//app.config.globalProperties.$backendUrl =  "http://localhost/traslados_back/api/"; // Define la URL del backend globalmente


//app.config.globalProperties.$backendUrl =  "http://localhost:8080/www_traslados/api/"; // Define la URL del backend globalmente

 //    app.config.globalProperties.$backendUrl =  "http://localhost/traslados_back/api/"; // Define la URL del backend globalmente

 //    app.config.globalProperties.$backendUrl =  "http://localhost:8080/traslados_back/api/";

